import {useContext} from "react";
import {stickyHeaderContext} from "./context";

/**
 * Read the current cumulative sticky offset from context.
 * Useful for components that need to position themselves relative to stacked
 * sticky headers (e.g. scroll-to-anchor calculations).
 */
export function useStickyOffset(): number {
  return useContext(stickyHeaderContext).offset;
}
